// extracted by mini-css-extract-plugin
module.exports = {"tu-dien-kinh-doanh":"DictionaryModule_tu-dien-kinh-doanh__oJYc3"};